import React, { useEffect, useState } from "react";
import Dashboard from "./Dashboard";
import axios from "axios";
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
import Logo from '../Images/logo.jpg';
import Fondo from '../Images/fondoPDF.jpg';
import { FaRegFilePdf } from "react-icons/fa6";
import '../css/gastos.css'

const url = process.env.REACT_APP_URL;

const Gastos = ({user, setUser}) => {

    const [gastosMateriales, setGastosMateriales] = useState([])
    const [gastosTramites, setGastosTramites] = useState([])
    const [gastosMaquinaria, setGastosMaquinaria] = useState([])
    const [gastosAdicionales, setGastosAdicionales] = useState([])
    const [datosObra, setDatosObra] = useState([])

    useEffect(() => {
        getGastosMateriales()
        getGastosTramites()
        getGastosMaquinaria()
        getGastosAdicionales()
        getDastosGeneralesObra()
    }, [])

    const getGastosMateriales = async () => {
        try{
            const response = await axios.get(url + 'gastos/materiales/' + user.idObra)
            if(response.data.length === 0){
                alert("Todavia no hay resgistro")
            }
            setGastosMateriales(response.data)
        }catch (error){
            alert("algo paso")
        }
    }

    const getGastosTramites = async () => {
        try{
            const response = await axios.get(url + 'gastos/tramites/' + user.idObra)
            setGastosTramites(response.data)
        }catch(error){
            alert("Algo paso")
        }
    }

    const getGastosMaquinaria = async () => {
        try{
            const response = await axios.get(url + 'gastos/maquinaria/' + user.idObra)
            setGastosMaquinaria(response.data)
        }catch(error){
            alert('Algo paso')
        }
    }

    const getGastosAdicionales = async () => {
        try{
            const response = await axios.get(url + 'gastos/adicionales/' + user.idObra)
            setGastosAdicionales(response.data)
        }catch(error){
            alert('Algo paso')
        }
    }

    const getDastosGeneralesObra = async () => {
        const response = await axios.get(url + 'obra/datosgenerales/' + user.idObra)
        setDatosObra(response.data)
    }

    function totalGastosMateriales(){
        var t = 0
        gastosMateriales.map(function (x){
            t += (x.cantEntMat) * (x.precioUni)
            
        })
        
        return t;
    }

    function totalGastosTramites(){
        var t = 0
        gastosTramites.map(function (x){
            t += x.total
        })
        return t;
    }

    function totalGastosMaquinaria(){
        var t = 0
        gastosMaquinaria.map(function (x){
            t += x.total
        })
        return t;
    }

    function totalGastosAdicionales(){
        var t = 0
        gastosAdicionales.map(function (x){
            t += x.total
        })
        return t;
    }

    function number(x){
        return x.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    }

    const generarPDF = () => {
        const doc = new jsPDF({format:"letter"});

        const nombreCliente = user.nombreCliente + " " + user.apellidoPCliente + " " + user.apellidoMCliente;
        const repreLegal = "ING. ROSALIO SUASTEGUI MOLINA";
        const repreObra = datosObra.nombreEmp + " " + datosObra.apellidoPaternoEmp + " " + datosObra.apellidoMaternoEmp;
        const nombreObra = datosObra.nombreObra;
        const ubicacionObra = datosObra.direccionObra;

        const columns = ["No.", "Concepto", "Total"]
        const data = [
            [1,"Gastos Materiales", "$" + number(totalGastosMateriales())],
            [2,"Gastos Materiales", "$" + number(totalGastosTramites())],
            [3,"Gastos Materiales", "$" + number(totalGastosMaquinaria())],
            [4,"Gastos Materiales", "$" + number(totalGastosAdicionales())],
            ["","Total:","$" + number(totalGastosMateriales() + totalGastosTramites() + totalGastosMaquinaria() + totalGastosAdicionales())]
        ]

        //fondo de pagina
        doc.addImage(Fondo, "JPEG", 0, 50, 200, 200);
        doc.setFontSize(20);

        //titulo
        doc.setTextColor(19,43,76)
        doc.setFont("times", "bold")
        doc.text("Gastos de obra", 70, 20);

        doc.setLineWidth(1.5);
        doc.line(10, 23, 200, 23);

        //logo de empresa
        doc.addImage(Logo, "JPEG", 14, 24, 25, 25);
        doc.setFontSize(15);

        //datos de obra
        doc.text("Obra: ", 45, 30);
        doc.text(nombreObra, 60, 30);
        doc.text("Ubicación: ", 45, 35);
        doc.text(ubicacionObra, 70, 35);
        doc.text("Ciudad: Chilpancingo", 45, 40);
        doc.text("Estado: Guerrero", 45, 45);
        doc.setFontSize(10);
        doc.text("Fecha: ", 165, 45);
        doc.text(fecha(), 180, 45);

        doc.setLineWidth(1);
        doc.line(10, 50, 200, 50);

        //tabla de datos
        doc.autoTable({
            theme: 'plain',
            styles: {
                font: 'times',
                fontSize: 12
            },
            startY: 55,
            head: [columns],
            body: data
        });

        doc.setDrawColor(19,43,76);

        doc.setLineWidth(1);

        const columns2 = ["Elaboro", "Vo. Bo.:", ""]
        const data2 = [
            ["ROSMO COIN S.A. DE C.V.","", ""],
            ["\r","\r","\r"],
            [repreLegal + "\rREPRESENTANTE LEGAL", repreObra.toUpperCase() + "\rREPRESENTANTE DE OBRA", nombreCliente.toUpperCase() + "\rDUEÑO DE OBRA"],
        ]

        doc.autoTable({
            theme: 'plain',
            styles: {
                fontSize: 10,
                halign: 'center'
            },
            headStyles: {
                fontSize: 11,
                cellWidth: 65
            },
            startY: 222,
            head: [columns2],
            body: data2
        });
        
        //linea para firma
        doc.setLineWidth(0.5);
        doc.line(15, 250, 78, 250);
        doc.line(83, 250, 142, 250);
        doc.line(148, 250, 205, 250);

        doc.line(14, 222, 14, 265);
        doc.line(80, 222, 80, 265);
        doc.line(145, 222, 145, 265);
        doc.line(210, 222, 210, 265);
        
        //lineas horizontales pie de pagina
        doc.line(14, 222, 210, 222);
        doc.line(14, 265, 210, 265);

        doc.output('dataurlnewwindow',{
            filename: 'gastos de obra'
        })
    }

    function fecha(){
        const date = new Date();

        const dia = date.getDate()
        const mes = date.getMonth()
        const anio = date.getFullYear()
        
        const fecha = dia + "/" + (mes + 1) + "/" + anio

        return fecha
    }
    
    return(
        <div>
            <Dashboard user={user} setUser={setUser}/>
            <div className="tabla">
                <table className="table table-bordered border-primary">
                    <thead className="table-primary">
                        <tr>
                            <th className="titulo-tabla" colspan="5"><h4>Gastos de obra</h4></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>#</th>
                            <th>Concepto</th>
                            <th width={150}>Total</th>
                        </tr>
                        <tr>
                            <td>1</td>
                            <td>Gastos Materiales</td>
                            <td align="right">$ {number(totalGastosMateriales())}</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td>Gastos Tramites</td>
                            <td align="right">$ {number(totalGastosTramites())}</td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td>Gastos Maquinaria</td>
                            <td align="right">$ {number(totalGastosMaquinaria())}</td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td>Gastos Adicionales</td>
                            <td align="right">$ {number(totalGastosAdicionales())}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th className="titulo-total" colSpan={2}>Total:</th>
                            <th className="titulo-total">${number(totalGastosMateriales() + totalGastosTramites() + totalGastosMaquinaria() +totalGastosAdicionales())}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div className="botones-accion">
                <button className="btn btn-danger" onClick={generarPDF}><span><FaRegFilePdf/> Generar</span></button>
            </div>
        </div>
    )
}

export default Gastos